// extracted by mini-css-extract-plugin
module.exports = {"social__buttons__control":"social__buttons__control-3XxmE","add__icon":"add__icon-2GMKV"};